import ReactMarkdown from 'react-markdown';
import styled from 'styled-components';
import Router from 'next/router';
import { useSelector } from 'src/store/store';
import config from 'config/config';
import CommunityLink from 'src/modules/shared/links/communityLink';
import SocialSharingButtons from 'src/modules/programs/components/socialSharingButtons';
import i18n from 'src/utils/translate';
import EnrollButton from 'src/modules/programs/components/enrollButton';
import { titleLarge, titleMedium } from 'styles-js/mixins/typography';
import { markdownStyles } from 'styles-js/markdown';
import { ExternalLink, BlockQuote, HtmlNode } from 'src/modules/programs/components/markdownRenderers';
export default function AboutContent() {
  const {
    details = {},
    modules
  } = useSelector(({
    pages
  }) => pages.programs);
  const {
    code,
    description,
    name,
    partnerName,
    supportedByCode,
    supportedByLogo,
    supportedByName
  } = details;
  const firstModuleCode = modules.find(module => module.sort === 1)?.code;
  const renderers = {
    blockquote: BlockQuote,
    link: ExternalLink,
    html: HtmlNode
  };
  return <Container data-sentry-element="Container" data-sentry-component="AboutContent" data-sentry-source-file="aboutContent.tsx">
      <Title data-sentry-element="Title" data-sentry-source-file="aboutContent.tsx">{i18n.t('About this program')}</Title>
      <ReactMarkdown escapeHtml={false} renderers={renderers} source={description || ''} data-sentry-element="ReactMarkdown" data-sentry-source-file="aboutContent.tsx" />
      <EnrollButtonContainer data-sentry-element="EnrollButtonContainer" data-sentry-source-file="aboutContent.tsx">
        <EnrollButton redirectPage={() => {
        Router.push(`/programs?slug=${code}&moduleCode=${firstModuleCode}`, `/programs/${code}/${firstModuleCode}`);
      }} data-sentry-element="EnrollButton" data-sentry-source-file="aboutContent.tsx" />
      </EnrollButtonContainer>
      {supportedByCode && <>
          <SmallHeading>{i18n.t('Created by:')}</SmallHeading>
          <CommunityLink name={name} slug={supportedByCode}>
            <CommunityImage alt={supportedByName} src={`${config.cdn.communityLogos}${supportedByLogo}_140x140.jpg`} />
          </CommunityLink>
        </>}
      {partnerName && <>
          <SmallHeading>{i18n.t('Funded by:')}</SmallHeading>
          <FundingImage alt={partnerName} src={`${config.cdn.programs}${code}/funded-by-logo.png`} />
        </>}
      <SocialButtonsSection data-sentry-element="SocialButtonsSection" data-sentry-source-file="aboutContent.tsx">
        <SmallHeading data-sentry-element="SmallHeading" data-sentry-source-file="aboutContent.tsx">{i18n.t('Share this program:')}</SmallHeading>
        <SocialSharingButtons name={name || ''} data-sentry-element="SocialSharingButtons" data-sentry-source-file="aboutContent.tsx" />
      </SocialButtonsSection>
    </Container>;
}
const Container = styled.div`
  ${markdownStyles};
`;
const Title = styled.h2`
  ${titleLarge};

  @media (${props => props.theme.underScreenSmall}) {
    ${titleMedium};
  }
`;
const SocialButtonsSection = styled.div`
  span.icon {
    font-size: 16px;
  }
`;
const EnrollButtonContainer = styled.div`
  margin-bottom: 30px;
`;
const SmallHeading = styled.span`
  display: block;
  margin-bottom: 8px;
`;
const CommunityImage = styled.img`
  border: ${({
  theme
}) => theme.greyLine};
  border-radius: 50%;
  height: 100px;
  width: 100px;
`;
const FundingImage = styled.img`
  height: 80px;
  width: auto;
`;